import { contentAPI, checkoutAPI, depictAPI } from '../config';

const getDataOptions = (body) => {
	let cookies;
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	if (typeof window !== 'undefined' && document.cookie) {
		cookies = document.cookie.split(';').reduce((acc, cookie) => {
			const [key, value] = cookie.split('=').map((section) => section.trim());
			return { ...acc, [key]: value };
		}, {});
	}

	const previewCode = cookies ? cookies.previewCode : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;
	if (!body.market) delete body.market;
	if (!body.pricelist) delete body.pricelist;
	if (!body.campaignSite) delete body.campaignSite;

	if (typeof process !== 'undefined' && process.env.CONTENT_API_KEY) {
		fetchOptions.headers = {
			'api-authorization': process.env.CONTENT_API_KEY,
		};
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').filter((part) => !!part).map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${contentAPI}${path}`, getDataOptions(body)).then((data) => data.text()).then((resp) => console.log('DEBUG: resp', resp)).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body))
		.then((resp) => resp.text())
		.then((data) => {
			if (data.slice(0, 1) !== '<') return JSON.parse(data);
			console.log('DEBUG: data', data);
			return data;
		}).catch((err) => console.log(`DEBUG: was not able to be fetched ${contentAPI}${encodedPath}`, err));
};

const getCheckoutOptions = (token, body, method) => {
	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
		headers: {},
	};

	fetchOptions.method = method;
	if (typeof process !== 'undefined' && process.env.CHECKOUT_API_KEY) {
		fetchOptions.headers = {
			'API-Authorization': `${process.env.CHECKOUT_API_KEY}`,
		};
	}

	if (token) fetchOptions.headers.Accept = `application/json, text/plain, */*; api-token:${token}`;
	else fetchOptions.headers.Accept = 'application/json, text/plain, */*;';

	if (typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchCheckout = (path, token, body = {}, method = 'GET') => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	return fetch(`${checkoutAPI}${encodedPath}`, getCheckoutOptions(token, body, method)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const getDepictOptions = (body = {}, method) => {
	const fetchOptions = {
		method,
		mode: 'cors',
		cache: 'no-cache',
		headers: {},
	};

	if (typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchDepict = (path, body = {}, method = 'GET') => {
	let fetchPath = `${depictAPI}${path.split('/').map((part) => encodeURIComponent(part)).join('/')}`;

	if (method === 'GET' && body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		const queryString = Object.keys(body).map((key) => `${key}=${body[key]}`).join('&');
		fetchPath = `${fetchPath}?${queryString}`;
		body = {};
	}

	return fetch(fetchPath, getDepictOptions(body, method)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

export { fetchData, fetchCheckout, fetchDepict };
